module.exports = __webpack_public_path__ + "img/card_reislighting_background.65d4968a.png";